import type { ArticleProps } from "@foodpilot/foods";
import { ArticleItem } from "../types";

export const mapArticlesToProps = (articles: ArticleItem[] = []): ArticleProps[] => {
    const articleItems = articles?.length > 0 ? articles : [];

    return articleItems.map((article, index) => ({
        title: article.title,
        description: article.description,
        imageSrc: article.imageSrc,
        isFirst: index === 0,
    }));
};
